import { useEffect, useState } from "react";
import { tracking } from '../../utils/tracking';
import { svgs } from "../../assets/svgs";
import sponsorsData from '../../data/sponsors_sponsors.json'

export const PartnerCards = () => {
   const [data, setData] = useState([]);

   //used for event that didn't finish yet
   const gettingTheData = async (url) => {
      const res = await fetch(url);
      const data = await res.json();
      const result = data.map(display_name => display_name.values);
      const filteredResult = result.filter(x => x[0].display_name !== "industry partner")
      const flatData = filteredResult.flat(1)
      setData(flatData);
   };

   useEffect(() => {
      //used for event that didn't finish yet
      // gettingTheData("https://youngstartup.io/api/cwebsite/get_sponsors");

      //used for event that finished
      const result = sponsorsData.map(display_name => display_name.values);
      const filteredResult = result.filter(x => x[0].display_name !== "industry partner")
      const flatData = filteredResult.flat(1)
      setData(flatData);
   }, []);

   return (
      <div className='partner-cards'>
         <header>
            <p>
               “One of the top events of the year for the invaluable content, presentation quality and opportunities to connect investors and founders.”
            </p>
            <p>
               - Tina Gregory, Early Growth
            </p>
         </header>
         <main >
            {
               data.map((partner, partnerIdx) => {
                  if (partner.sponsor_type === 'industry_partners') return <div key={partnerIdx}></div>
                  // let numOfmembers = JSON.parse(partner.team_members).length
                  return (
                     <div className='partner'>
                        <section className='details'>
                           <h5>{partner.display_name} Partner</h5>
                           <img src={require("../../assets/imgs/sponsor-logos/" + partner.logo_url)} alt='partner-logo' />
                           <p>{partner.description}</p>
                           <div className="btn-container">
                              <a className='btn' href={partner.website} target="_blank" rel='noreferrer'>learn more</a>
                           </div>
                        </section>
                        {partner?.team_members && <section className='members'>
                           {
                              JSON.parse(partner.team_members).map((member, memberIdx) =>
                                 <div className='member' key={member.id}>
                                    <img src={require("../../assets/imgs/sponsor-member-headshot/" + member.headshot_url)} alt="team-member" />
                                    <h6>{member.firstname} {member.lastname}</h6>
                                    <p>{member.jobtitle}</p>
                                    <a href={member.linkedin} target='_blank' rel='noreferrer'>{svgs.linkedin}</a>
                                 </div>
                              )
                           }
                        </section>}

                     </div>
                  )
               }
               )
            }
         </main>
      </div>
   )
}
